import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ESuburbanUtility } from '../../../../../../../json_query';
import { changeSuburbanUtility } from '../../../../../../state/advanced/suburban_utilities';
import { utilitiesFromJsonQuery } from '../../../../../../../utils/utilities';

import { SuburbanUtilities as SuburbanUtilitiesComponent, ISuburbanUtilitiesProps } from './suburbanUtilities';

type TSuburbanUtilitiesStateProps = Pick<ISuburbanUtilitiesProps, 'value'>;
type TSuburbanUtilitiesDispatchProps = Pick<ISuburbanUtilitiesProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TSuburbanUtilitiesStateProps {
  return {
    value: utilitiesFromJsonQuery(state.filters.jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TSuburbanUtilitiesDispatchProps {
  return {
    onChange: (utility: ESuburbanUtility, value: boolean) => {
      dispatch(changeSuburbanUtility(utility, value));
    },
  };
}

export const SuburbanUtilities = connect(mapStateToProps, mapDispatchToProps)(SuburbanUtilitiesComponent);
